import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useFirebaseRemoteConfig } from './useFirebaseRemoteConfig';
import { useConfig } from './LocalConfigProvider';
const RemoteConfig = createContext({ isLoading: true });
export const useRemoteConfig = () => useContext(RemoteConfig);
export const RemoteConfigProvider = ({ children, firebaseConfig, defaults = {} }) => {
    const { values, isLoading, error } = useFirebaseRemoteConfig(firebaseConfig, defaults);
    return _jsx(RemoteConfig.Provider, { value: { values, isLoading, error }, children: children });
};
export const RemoteConfigProviderWrap = ({ children, defaults = {} }) => {
    const { appApi } = useConfig();
    const { values, isLoading, error } = useFirebaseRemoteConfig(appApi === null || appApi === void 0 ? void 0 : appApi.firebase, defaults);
    return _jsx(RemoteConfig.Provider, { value: { values, isLoading, error }, children: children });
};
//# sourceMappingURL=RemoteConfigProvider.js.map